import Login from './views/Login'
import Users from './views/Users'
import Vendors from './views/ManaggeCentralStore'
import AllOrderList from './views/AllOrderList'
import Products from '../src/views/Products'
import MangeCategory from '../src/views/ManageCategory'
import MangeSubCategory from '../src/views/ManageSubCategory'
import { ReactComponent as OrderIcon } from './assets/svg/order.svg'
import BurstModeIcon from '@mui/icons-material/BurstMode';
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit';
import CategoryIcon from '@mui/icons-material/Category';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import GroupIcon from '@mui/icons-material/Group';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SuperAdminDashboard from './views/SuperAdminDashboard'
import SingleOrderDetails from './views/SingleOrderDEtails'
import PackageAdminDashBoard from './views/PackageAdmin'
import PackageSingleORderDetails from "./views/PackageOrderDetails"
import PackageNewOrderList from "./views/PackageNewOrderList"
import PackagePackedOrderList from "./views/PackagePackedOrderList"
import ManageCatlog from './views/ManageCatlog'
import BillingadminDashboard from './views/BillingAdmin'
import CentralAdminDashBoard from './views/AdminDashbord'
import HomeIcon from '@mui/icons-material/Home';
import CentralAdminProducts from './views/CentralAdminProducts'
import MAnageLocalStore from './views/MAnageLocalStore'
import ManageLocalAdmins from './views/ManageLocalAdmins'
import LocalAdminProducts from './views/LocalAdminProducts'
import ManagelocalUsers from './views/ManagelocalUsers'
import LocalAdminDashboard from './views/LocalAdminDashboard'
import AllCustomerList from './views/AllCustomerList'
import ViewCustomerDetails from './views/ViewCustomerDetails'
import BasicTabs from './views/PackingWorkerTab'
import BillingWorkerTab from './views/BillingWorkerTab'
import PackageTabForProgress from './views/PackageTabForProgress'
import CSSku from './components/AddSKU/CSSku'
import CSRepletion from './views/CSRepletion'
import ManageReplenationForBillingAdmin from './views/ManageReplenationForBillingAdmin'
import ViewDetailsRepllenation from './views/ViewDetailsRepllenation'
import CreateNewReplentionRequest from './views/CreateNewReplentionRequest'
import CSAdminViewDetailsRepllenation from './views/CSAdminViewDetailsRepllenation'
import LSRepletion from './views/LSRepletion'
import WorkerReportForCSAdmin from './views/WorkerReportForCSAdmin'
//import TimeSlotConfigLS from './views/TimeSlotConfigLS'
import RiderConfigPage from './views/RiderConfigPage' 
import Banner from './components/Vendor/Banner'
import LandingPage from './components/Vendor/LandingPage'
import CustomerCOnfiguration from './components/AdminConfiguration/CustomerCOnfiguration'
import ManageSystemConfig from './views/ManageSystemConfig'
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import BulkCreditToNestCash from './components/Vendor/BulkCreditToNestCash'
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import RiderReport from './views/RiderReport'
import RiderReportList from './views/RiderReportList'
import ManageRiders from './views/ManageRiders'
import AutoAssignRiderResultPage from './views/AutoAssignRiderResultPage'
import AdminLockRiderResultPage from './views/AdminLockRiderResultPage'
import RiderList from './views/RiderList'
import RiderOutForDelivery from './views/RiderOutForDelivery'
import ManageCustomerType from './views/ManageCustomerType'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ManageCoupons from './views/ManageCoupons'
import DiscountIcon from '@mui/icons-material/Discount';
import ManageReferrals from './views/ManageReferrals'
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import ReferralHistory from './views/ReferralHistory'
import YoutubeSearchedForIcon from '@mui/icons-material/YoutubeSearchedFor';
import DataRequestTab from './views/DataRequestTab'
import Inventory2Icon from '@mui/icons-material/Inventory2';
import TaxRequestTab from './views/TaxRequestTab'
import TopicIcon from '@mui/icons-material/Topic';
import CustomerTimeSlotForLS from './components/AdminConfiguration/CustomerTimeSlotForLS'
import ManageCustomerTimeSlot from './views/ManageCustomerTimeSlot'
import QuatationRequest from './views/QuatationRequest'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import QuatationDetails from './views/QuatationDetails'
import OrderStats from './views/OrderStats'
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import DayWiseOrderStats from './views/DayWiseOrderStats'
import WeeklySalesByCategory from './views/WeeklySalesByCategory'
import SummarizeIcon from '@mui/icons-material/Summarize';
import UpgradeCustomer from './views/UpgradeCustomer'
//import UpgradeToPremium from './views/UpgradeToPremium'
import NestPassManagement from './views/NestPassManagement'
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import UpgradeToNestPass from './views/UpgradeToNestPass'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ManageOffer from './views/ManageOffer'
import ManagePurchaseOffer from './views/ManagePurchaseOffer'
import AssignRider from './views/AssignRider'
import AasignRiderResultPage from './views/AasignRiderResultPage'
import ManageLandingPage from './components/Vendor/ManageLandingPage'
import PictureInPictureIcon from '@mui/icons-material/PictureInPicture';
import OrderSTatusByIems from './views/OrderSTatusByIems'
import ItemsbyTimeSlot from './views/ItemsbyTimeSlot'
import SendPushNotification from './views/SendpushNotification'
import OutOfStockProductReport from './views/OutOfStockProductReport'
import NestPassCustomersPage from './views/NestPassCustomersPage'
import OrdersbyTimeSlot from './views/OrdersbyTimeSlot'
import AddAlertIcon from '@mui/icons-material/AddAlert'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import CelebrationIcon from '@mui/icons-material/Celebration';
import RiderStatsTable from './views/RiderStatsTable'
import AnalyticsDashboard from './views/AnalyticsDashboard'
import BarChartIcon from '@mui/icons-material/BarChart';
import LSViewDetailsRepllenation from './views/LSViewDetailsRepllenation'
var routes = [
  {
    path: '/dashboard',
    name: 'Home',
    icon: HomeIcon,
    component: SuperAdminDashboard,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },

  {
    path: '/mangecategory',
    name: 'Manage Category',
    icon: CategoryIcon,
    component: MangeCategory,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/mangesubcategory',
    name: 'Manage Sub-Category',
    icon: SyncProblemIcon,
    component: MangeSubCategory,
    layout: '/super_admin',
    // appearInSidebar: true,
    admin: true
  },
  {

    path: '/manageCatalog',
    name: 'Manage Catalog',
    icon: HorizontalSplitIcon,
    component: ManageCatlog,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/products',
    name: 'Manage Products',
    icon: FactCheckIcon,
    component: Products,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {

    path: '/managestore',
    name: 'Manage Central Store',
    icon: StorefrontIcon,
    component: Vendors,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/users',
    name: 'Manage Admin User',
    icon: GroupIcon,
    component: Users,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/dashboard',
    name: 'Home',
    icon: HomeIcon,
    component: CentralAdminDashBoard,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },
  {
    path: '/analyticsdashboard',
    name: 'Analytics',
    icon: BarChartIcon,
    component: AnalyticsDashboard,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },
  {
    path: '/allorders',
    name: 'All Order',
    icon: FeaturedPlayListIcon,
    component: AllOrderList,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },
  {
    path: '/datewiseorderstats',
    name: 'Sales Report',
    icon: SummarizeIcon,
    component: DayWiseOrderStats,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'reports'
  },
  {
    path: '/weekly-sales-by-category',
    name: 'Weekly Sales',
    icon: CategoryIcon,
    component: WeeklySalesByCategory,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'reports'
  },
  {
    path: '/orderstats',
    name: ' Order Status',
    icon: QueryStatsIcon,
    component: OrderStats,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'reports'
  },
  {
    path: '/orderstatusbyitem',
    name: ' Item Status ',
    icon: QueryStatsIcon,
    component: OrderSTatusByIems,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'reports'
  },
  {
    path: '/allcustomers',
    name: 'All Customers',
    icon: GroupIcon,
    component: AllCustomerList,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },
  {
    path: '/products',
    name: 'Manage Products',
    icon: FactCheckIcon,
    component: CentralAdminProducts,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },
  {
    path: '/sku',
    name: 'Manage SKUS',
    icon: SyncProblemIcon,
    component: CSSku,
    layout: '/cs_admin',
    // appearInSidebar: true,
    centralAdmin: true
  },
  {

    path: '/managestore',
    name: 'Stores',
    icon: StorefrontIcon,
    component: MAnageLocalStore,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'management'
  },
  {
    path: '/users',
    name: 'Admins',
    icon: GroupIcon,
    component: ManageLocalAdmins,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'management'
  },
  {
    path: '/customertype',
    name: 'Customer Type',
    icon: PersonAddAltIcon,
    component: ManageCustomerType,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group:'systemsetting'
  },
    {
    path: '/upgradeToNestPass',
    name: 'Bulk NestPass',
    icon: FileUploadIcon,
    component: UpgradeToNestPass,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'nestpass'
  },
    {
    path: '/managenestpass',
    name: 'NestPass',
    icon: LoyaltyIcon,
    component: NestPassManagement,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'nestpass'
  },
    {
    path: '/nestPassdashboard',
    name: 'Users',
    icon: LocalOfferIcon,
    component: NestPassCustomersPage,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'nestpass'
  },
  {
    path: '/sendPushNotification',
    name: 'Notifications',
    icon: AnnouncementIcon,
    component: SendPushNotification,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'promotions'
  },
  {
    path: '/bulkCreditToNestCash',
    name: 'NestCash',
    icon: ShoppingCartCheckoutIcon,
    component: BulkCreditToNestCash,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'promotions'
  },
    {
    path: '/manageCoupons',
    name: 'Coupons',
    icon: DiscountIcon,
    component: ManageCoupons,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'promotions'
  },
   {
    path: '/managePurchaseoffer',
    name: 'Purchase Offer',
    icon: CelebrationIcon,
    component: ManagePurchaseOffer,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'promotions'
  }, 
    {
    path: '/manageReferrals',
    name: 'Referrals',
    icon: ReplyAllIcon,
    component: ManageReferrals,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'promotions'
  },
   {
    path: '/referralHistory',
    name: 'Referral History',
    icon: YoutubeSearchedForIcon,
    component: ReferralHistory,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'promotions'
  },
  {
    path: '/OrderDetails',
    name: 'Order Details',
    icon: FeaturedPlayListIcon,
    component: SingleOrderDetails,
    layout: '/cs_admin',
    centralAdmin: true
  },
  {
    path: '/workerdetails',
    name: 'Worker Details',
    icon: 'ni ni-tv-2 text-primary',
    component: WorkerReportForCSAdmin,
    layout: '/cs_admin',
    centralAdmin: true
  },
  {
    path: '/manageSpecialoffer',
    name: 'Special Offer',
    icon: LocalOfferIcon,
    component: ManageOffer,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'landing'
  }, 
  {
    path: '/banners',
    name: 'Banner',
    icon: BurstModeIcon,
    component: Banner,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'landing'
  },
  {
    path: '/landingpage',
    name: 'Landing Page',
    icon: NewspaperIcon,
    component: LandingPage,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'landing'
  },
  {
    path: '/managedisplaytype',
    name: 'Manage Display',
    icon: PictureInPictureIcon,
    component: ManageLandingPage,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'landing'
  },
  {
    path: '/customerConfig',
    name: 'User Config',
    icon: ManageAccountsIcon,
    component: CustomerCOnfiguration,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group:'systemsetting'
  },
    {
  path: '/managesystemconfig',
  name: 'System Config',
  icon: MoreTimeIcon,
  component: ManageSystemConfig, 
  layout: '/cs_admin',
  appearInSidebar: true,
  centralAdmin: true,
  group:'systemsetting'
},
  /*{
    path: '/upgradetopremium',
    name: 'Premium Switch',
    icon: LocalOfferIcon,
    component: UpgradeToPremium,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },
  {
    path: '/upgradecustomer',
    name: 'Bulk Premium',
    icon: LocalOfferIcon,
    component: UpgradeCustomer,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true
  },*/
  {
    path: '/OutOfStockproducts',
    name: 'Stock Alerts',
    icon: AddAlertIcon,
    component: OutOfStockProductReport,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'inventory'
  },

  {
    path: '/repletion',
    name: 'Repletion',
    icon: SyncProblemIcon,
    component: CSRepletion,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'inventory'
  },
  {
    path: '/manageExtralData',
    name: 'Manage Data',
    icon: Inventory2Icon,
    component: DataRequestTab,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'inventory'
  },
    {
    path: '/manageTax',
    name: 'Manage Tax',
    icon: TopicIcon,
    component: TaxRequestTab,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'inventory'
  },
  {
    path: '/manageQuotationData',
    name: 'Quotation',
    icon: RequestQuoteIcon,
    component: QuatationRequest,
    layout: '/cs_admin',
    appearInSidebar: true,
    centralAdmin: true,
    group: 'inventory'
  },
  {
    path: '/customerdetails',
    name: 'Customer Details',
    icon: 'ni ni-tv-2 text-primary',
    component: ViewCustomerDetails,
    layout: '/cs_admin',
    centralAdmin: true
  },
  {
    path: '/quotationdetails',
    name: 'Customer Details',
    icon: 'ni ni-tv-2 text-primary',
    component: QuatationDetails,
    layout: '/cs_admin',
    centralAdmin: true
  },
  // {
  //   path: '/customerTimeSlotConfig',
  //   name: 'Customer Time Slot',
  //   icon: AccessTimeIcon,
  //   component: CustomerTimeSlot,
  //   layout: '/cs_admin',
  //   appearInSidebar: true,
  //   centralAdmin: true
  // },
  // {
  //   path: '/customerTimeSlotConfig',
  //   name: 'Customer Time Slot',
  //   icon: AccessTimeIcon,
  //   component: ManageCustomerTimeSlot,
  //   layout: '/cs_admin',
  //   appearInSidebar: true,
  //   centralAdmin: true
  // },
  {
    path: '/detilerepletion',
    name: 'Details Repletion',
    icon: SyncProblemIcon,
    component: CSAdminViewDetailsRepllenation,
    layout: '/cs_admin',
    centralAdmin: true
  },
  {
    path: '/detilerepletion',
    name: 'Details Repletion',
    icon: SyncProblemIcon,
    component: LSViewDetailsRepllenation,
    layout: '/local_admin',
    centralAdmin: true
  },
  {
    path: '/dashboard',
    name: 'Home',
    icon: HomeIcon,
    component: LocalAdminDashboard,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/allorders',
    name: 'All Order',
    icon: FeaturedPlayListIcon,
    component: AllOrderList,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/products',
    name: 'Manage Products',
    icon: FactCheckIcon,
    component: LocalAdminProducts,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/repletion',
    name: 'Manage Repletion',
    icon: SyncProblemIcon,
    component: LSRepletion,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },

  {
    path: '/OrderDetails',
    name: 'Order Details',
    icon: FeaturedPlayListIcon,
    component: SingleOrderDetails,
    layout: '/local_admin',
    localAdmin: true
  },
  {
    path: '/users',
    name: 'Manage  User',
    icon: GroupIcon,
    component: ManagelocalUsers,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
  path: '/manageriders',
  name: 'Manage Riders',
  icon: TwoWheelerIcon, 
  component: ManageRiders,
  layout: '/local_admin',
  appearInSidebar: true,
  localAdmin: true
},
{
    path: '/autoAssignRiderResults',
    name: 'Manage Riders ',
    icon: TwoWheelerIcon,
    component: AutoAssignRiderResultPage,
    layout: '/local_admin',
    // appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/adminlockriderresult',
    name: 'Manage Riders ',
    icon: TwoWheelerIcon,
    component: AdminLockRiderResultPage,
    layout: '/local_admin',
    // appearInSidebar: true,
    localAdmin: true
  },
  
  {
    path: '/riderreport',
    name: 'Rider Report',
    icon: TwoWheelerIcon,
    component: RiderReportList,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
      path: '/riderStatsTable',
      name: 'Ride Status',
      icon: TwoWheelerIcon,
      component: RiderStatsTable,
      layout: '/local_admin',
      appearInSidebar: true,
      localAdmin: true
    },
  // {
  //   path: '/assignrider',
  //   name: 'Assign Rider ',
  //   icon: TwoWheelerIcon,
  //   component: AssignRider,
  //   layout: '/local_admin',
  //   appearInSidebar: true,
  //   localAdmin: true
  // },
  {
    path: '/assignriderdetails',
    name: 'Assign Rider ',
    icon: TwoWheelerIcon,
    component: AasignRiderResultPage,
    layout: '/local_admin',
    // appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/riderreportDetails',
    name: 'Rider Report Details',
    icon: FeaturedPlayListIcon,
    component: RiderReport,
    layout: '/local_admin',
    localAdmin: true
  },
  {
    path: '/riderlist',
    name: 'Out For Delivery',
    icon: FeaturedPlayListIcon,
    component: RiderList,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/customerTimeSlotConfig',
    name: 'Customer Time Slot',
    icon: AccessTimeIcon,
    component: ManageCustomerTimeSlot,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/rideroutfordeliverydetails',
    name: 'Rider Out For Delivery Details',
    icon: FeaturedPlayListIcon,
    component: RiderOutForDelivery,
    layout: '/local_admin',
    localAdmin: true
  },
  /*{
    path: '/ridertimeconfig',
    name: 'Time  Configuration',
    icon: AccessTimeIcon,
    component: TimeSlotConfigLS,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },*/
  {
    path: '/ridertimeconfig',
    name: 'Rider Config',
    icon: AccessTimeIcon,
    component: RiderConfigPage,
    layout: '/local_admin',
    appearInSidebar: true,
    localAdmin: true
  },
  {
    path: '/dashboard',
    name: 'Home',
    icon: HomeIcon,
    component: BillingadminDashboard,
    layout: '/billing_admin',
    appearInSidebar: true,
    billingAdmin: true
  },
  {
    path: '/billinglist',
    name: ' Order',
    icon: FeaturedPlayListIcon,
    component: BillingWorkerTab,
    layout: '/billing_admin',
    appearInSidebar: true,
    billingAdmin: true
  },
  {
    path: '/repletion',
    name: 'Manage Repletion',
    icon: SyncProblemIcon,
    component: ManageReplenationForBillingAdmin,
    layout: '/billing_admin',
    appearInSidebar: true,
    billingAdmin: true
  },
  {
    path: '/requestrepletion',
    name: 'Manage Repletion',
    icon: SyncProblemIcon,
    component: CreateNewReplentionRequest,
    layout: '/billing_admin',
    billingAdmin: true
  },
  {
    path: '/detilerepletion',
    name: 'Details Repletion',
    icon: SyncProblemIcon,
    component: ViewDetailsRepllenation,
    layout: '/billing_admin',
    billingAdmin: true
  },
  {
    path: '/OrderDetails',
    name: 'Order Details',
    icon: FeaturedPlayListIcon,
    component: PackageSingleORderDetails,
    layout: '/billing_admin',
    billingAdmin: true
  },
  {
    path: '/nweorderlist',
    name: 'In Progress Orders',
    icon: OrderIcon,
    component: PackageNewOrderList,
    layout: '/billing_admin',
    billingAdmin: true
  },

  {
    path: '/packedorderlist',
    name: 'Completed Orders',
    icon: OrderIcon,
    component: PackagePackedOrderList,
    layout: '/billing_admin',
    billingAdmin: true
  },
  {
    path: '/dashboard',
    name: 'Home',
    icon: HomeIcon,
    component: PackageAdminDashBoard,
    layout: '/package_admin',
    appearInSidebar: true,
    packageAdmin: true
  },
  {
    path: '/orderlist',
    name: ' Orders',
    icon: FeaturedPlayListIcon,
    component: BasicTabs,
    layout: '/package_admin',
    appearInSidebar: true,
    packageAdmin: true
  },
  {
    path: '/OrdersbyTimeSlot',
    name: ' Orders By TimeSlot',
    icon: QueryStatsIcon,
    component: OrdersbyTimeSlot,
    layout: '/package_admin',
    appearInSidebar: true,
    packageAdmin: true
  },
  {
    path: '/ItemsbyTimeSlot',
    name: ' Items by TimeSlot',
    icon: QueryStatsIcon,
    component: ItemsbyTimeSlot,
    layout: '/package_admin',
    appearInSidebar: true,
    packageAdmin: true
  },
  {
    path: '/OrderDetails',
    name: 'Order Details',
    icon: FeaturedPlayListIcon,
    component: PackageSingleORderDetails,
    layout: '/package_admin',
    admin: true
  },
  {
    path: '/nweorderlist',
    name: 'In Progress Orders',
    icon: OrderIcon,
    component: PackageTabForProgress,
    layout: '/package_admin',
    packageAdmin: true
  },

  {
    path: '/packedorderlist',
    name: 'Completed Orders',
    icon: OrderIcon,
    component: PackagePackedOrderList,
    layout: '/package_admin',
    packageAdmin: true
  },
  {
    path: '/login',
    name: 'Login',
    icon: 'ni ni-key-25 text-info',
    component: Login,
    layout: '/auth',
    appearInSidebar: false
  },

]
export default routes
